module.exports = __webpack_public_path__ + "img/img_32389_0_124.beb303b3.png";